(function () {
  'use strict';
  var CLE = 'lysGa4SelectEnAttente';

  function devise(secours) {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {}
    return secours || null;
  }

  /* Attend que le gtag.js de l'app soit réellement chargé ET configuré. */
  function quandPret(cb) {
    var n = 0;
    (function tick() {
      var pret = false;
      try {
        pret = !!(window.google_tag_manager && Object.keys(window.google_tag_manager).length > 0);
      } catch (e) {}
      if (pret) return cb(true);
      if (n++ > 120) return cb(false);          // ~18 s puis abandon
      setTimeout(tick, 150);
    })();
  }

  function envoyer(nom, params) {
    quandPret(function (pret) {
      if (!pret) return;
      try {
        params.transport_type = 'beacon';
        if (typeof window.gtag === 'function') { window.gtag('event', nom, params); return; }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(['event', nom, params]);
      } catch (e) {}
    });
  }

  /* ─── 1. rejeu d'un select_item resté en attente (page précédente) ─── */
  function rejouer() {
    var brut;
    try { brut = window.sessionStorage.getItem(CLE); } catch (e) { return; }
    if (!brut) return;
    try { window.sessionStorage.removeItem(CLE); } catch (e) {}
    var p;
    try { p = JSON.parse(brut); } catch (e) { return; }
    if (!p || !p.params || !p.t || (Date.now() - p.t) > 120000) return;
    envoyer('select_item', p.params);
  }
  rejouer();

  /* ─── 2. la liste de la page courante, s'il y en a une ─── */
  var el = document.querySelector('script[type="application/json"][id^="lysGa4List-"]');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent || el.innerHTML); } catch (e) { return; }
  if (!cfg || !cfg.items || !cfg.items.length) return;

  envoyer('view_item_list', {
    item_list_id: cfg.list_id,
    item_list_name: cfg.list_name,
    currency: devise(cfg.currency),
    items: cfg.items.slice(0, 30)
  });

  /* ─── 3. select_item au clic sur une carte ─── */
  function handleDe(href) {
    try {
      var m = String(href).split('?')[0].match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    } catch (e) { return null; }
  }

  document.addEventListener('click', function (ev) {
    var a = null;
    try { a = ev.target && ev.target.closest ? ev.target.closest(cfg.selector) : null; } catch (e) { return; }
    if (!a) return;
    var h = handleDe(a.getAttribute('href') || '');
    var i = (h && cfg.handles) ? cfg.handles.indexOf(h) : -1;
    if (i < 0) {
      try { i = Array.prototype.indexOf.call(document.querySelectorAll(cfg.selector), a); } catch (e) { i = -1; }
    }
    if (i < 0 || !cfg.items[i]) return;

    var params = {
      item_list_id: cfg.list_id,
      item_list_name: cfg.list_name,
      currency: devise(cfg.currency),
      items: [cfg.items[i]]
    };
    /* ON N'ÉMET PAS ICI : au clic, la navigation coupe le hit une fois sur deux (mesuré le
       28/07). On consigne, et la page suivante — qui charge ce même fichier — le rejoue,
       juste avant son view_item. Un seul émetteur = aucun doublon possible. */
    try { window.sessionStorage.setItem(CLE, JSON.stringify({ t: Date.now(), params: params })); } catch (e) {}
  }, true);
})();
